import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import LinearProgress from '@mui/material/LinearProgress';

const StyledLinearProgress = styled(LinearProgress)`
  &.LinearProgress-determinate {
    border-radius: ${props => props.theme.radius(1)};
    .MuiLinearProgress-bar1Determinate {
      border-radius: ${props => props.theme.radius(1)};
    }
  }
  
  &.Skeleton {
    transform: scale(1, 1);
  }
  
  ${ComponentStyles}
`;

StyledLinearProgress.propTypes = {
  theme: PropTypes.object
};

export default StyledLinearProgress;
